import React from 'react';
import { Typography, Button } from '@sm/wds-react';
import { T, defineMessages } from '@sm/intl';

import './four-oh-four-error.scss';

const COPY = defineMessages({
  SORRY_MESSAGE: {
    id: 'FourOhFourError.sorryMessage',
    defaultMessage: "We're sorry",
    description: '[Type: Label][Vis.: med] - We are sorry message',
  },
  CANT_FIND_PAGE: {
    id: 'FourOhFourError.cantFindPage',
    defaultMessage: "We can't find the page you're looking for.",
    description: '[Type: Label][Vis.: med] - Cant find page message',
  },
  CHECK_URL: {
    id: 'FourOhFourError.checkURL',
    defaultMessage:
      "Please check the URL you entered to make sure it's spelled correctly.",
    description: '[Type: Label][Vis.: med] - check URL subtitle',
  },
  HELP_FIND_WAY: {
    id: 'FourOhFourError.helpFindWay',
    defaultMessage:
      'Still not sure how to get to the page you want? Maybe we can help you find your way:',
    description: '[Type: Label][Vis.: med] - Help find your way subtitle',
  },
  SIGN_UP_FREE: {
    id: 'FourOhFourError.signUpFree',
    defaultMessage: 'Sign Up FREE',
    description: '[Type: Label][Vis.: med] - Sign up free button',
  },
});

const FourOhFourError = () => (
  <div className="sm-four-oh-four-error" data-testid="FourOhFourError">
    <div className="sm-four-oh-four-error__message-wrapper">
      <Typography variant="pageTitle">
        <T desc={COPY.SORRY_MESSAGE} />
      </Typography>
      <div className="sm-four-oh-four-error__message-container">
        <Typography
          component="section"
          variant="sectionTitle"
          className="wds-p-1"
        >
          <T desc={COPY.CANT_FIND_PAGE} />
        </Typography>
        <Typography component="div" variant="body" className="wds-p-1">
          <p>
            <T desc={COPY.CHECK_URL} />
          </p>
          <p>
            <T desc={COPY.HELP_FIND_WAY} />
          </p>
        </Typography>

        <Typography component="div" variant="cardTitle" className="wds-p-1">
          Want to create your own survey?
        </Typography>

        <Button color="upgrade" href="/user/sign-up/?ut_source=404_page">
          <T desc={COPY.SIGN_UP_FREE} />
        </Button>
      </div>
    </div>
  </div>
);

export default FourOhFourError;
